module.exports = __webpack_public_path__ + "img/ba75b049f14fc33a3cbba103162aeccc.png";